import classNames from 'classnames'
import { isMobile } from 'components/utils'
import { CustomColorsRef } from 'types/general'

interface QuantityBubbleProps {
  selecteds: number
  className?: string
}

const QuantityBubble = ({ selecteds, className }: QuantityBubbleProps) => {
  const mobile = isMobile()
  
  if (selecteds === 0) {
    return null
  }

  return (
    <div
      className={classNames('absolute transform transition-all duration-200 ease-in-out text-xs font-semibold flex items-center justify-center', {
          'bg-imovPrimary text-white shadow-sm min-w-[18px] h-[18px] rounded-full -top-1 -right-1': !mobile,
          'top[30%] right-0 h-8 w-8 rounded-l-xl': mobile,
        },
        className
      )}
      style={{
        backgroundColor: CustomColorsRef.Primary,
        color: CustomColorsRef.White,
      }}
    >
      {selecteds > 99 ? '99+' : selecteds}
    </div>
  )
}

export default QuantityBubble
